import { type QueryFunctionContext } from "@tanstack/react-query";
import { type CardReportingItem } from "components/cards/CardReporting/CardReporting";
import packsDataService from "../../../Licensing/Packs/services/packsDataService";
import { type CustomerPacksSummaryResponse } from "features/Licensing/Packs/types/state";
import { type PerformanceFilter } from "features/Library/Common/utils/performanceUtils";

type QueryContextCustomer = QueryFunctionContext<[_key: string, customerId: number, filter: PerformanceFilter]>;

export const getCustomerPacksSummary = async ({
  queryKey,
  signal,
}: QueryContextCustomer): Promise<CustomerPacksSummaryResponse> => {
  const [_key, customerId, filter] = queryKey;
  const { data } = await packsDataService.getCustomerPacksSummary({ customerId, ...filter }, signal);
  return data;
};

export const transformToCardReportingItems = (data: CustomerPacksSummaryResponse): CardReportingItem[] => {
  return [
    {
      statDescription: "Packs",
      stat: data.PacksCount,
      popupBody: "The total number of purchased packs in my account.",
    },
    {
      statDescription: "Licenses",
      stat: data.LicensesCount,
      popupBody: "The total number of licenses available across all purchased packs.",
    },
    {
      statDescription: "Licenses Issued",
      stat: data.LicensesIssued,
      popupBody: "The total number of licenses issued across purchased packs.",
    },
    {
      statDescription: "Issued Rate",
      stat: (data.IssuedRate * 100).toFixed(2),
      isStatPercentage: true,
      popupBody: "The percentage of licenses issued compared to the total number available.",
    },
  ];
};

export const transformToOverviewCardReportingItems = (data: CustomerPacksSummaryResponse): CardReportingItem[] => {
  return [
    {
      statDescription: "Packs",
      stat: data.PacksCount,
      popupBody: "The total number of purchased packs in my account.",
    },
    {
      statDescription: "Licenses",
      stat: data.LicensesCount,
      popupBody: "The total number of licenses available across all purchased packs.",
    },
    {
      statDescription: "Licenses Issued",
      stat: data.LicensesIssued,
      popupBody: "The total number of licenses issued across purchased packs.",
    },
    {
      statDescription: "Percent Issued",
      stat: (data.IssuedRate * 100).toFixed(2),
      isStatPercentage: true,
      popupBody: "The percentage of licenses issued compared to the total number available.",
    },
  ];
};
